/* global axios */
/**
 * Chat Rooms API - AI Focus v4.8
 * API client for internal chat rooms
 */

import ApiClient from './ApiClient';

class ChatRoomsAPI extends ApiClient {
  constructor() {
    super('chat_rooms', { accountScoped: true });
  }

  // Listar todas as salas de chat
  get() {
    return axios.get(this.url);
  }

  // Mostrar detalhes de uma sala
  show(roomId) {
    return axios.get(`${this.url}/${roomId}`);
  }

  // Criar nova sala de chat
  create(data) {
    return axios.post(this.url, data);
  }

  // Atualizar sala de chat
  update(roomId, data) {
    return axios.patch(`${this.url}/${roomId}`, data);
  }

  // Deletar sala de chat
  delete(roomId) {
    return axios.delete(`${this.url}/${roomId}`);
  }

  // Marcar sala como lida
  markAsRead(roomId) {
    return axios.post(`${this.url}/${roomId}/mark_as_read`);
  }

  // Atualizar avatar da sala
  updateAvatar(roomId, file) {
    const formData = new FormData();
    formData.append('avatar', file);
    return axios.patch(`${this.url}/${roomId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // Deletar avatar da sala
  deleteAvatar(roomId) {
    return axios.delete(`${this.url}/${roomId}/destroy_avatar`);
  }

  // Obter membros da sala
  getMembers(roomId) {
    return axios.get(`${this.url}/${roomId}/chat_room_members`);
  }

  // Adicionar membros à sala
  addMembers(roomId, memberIds) {
    return axios.post(`${this.url}/${roomId}/chat_room_members`, {
      user_ids: memberIds,
    });
  }

  // Remover membro da sala
  // A API espera user_ids no body, não um ID na URL
  removeMember(roomId, memberId) {
    return axios.delete(`${this.url}/${roomId}/chat_room_members`, {
      data: { user_ids: [memberId] },
    });
  }

  // Buscar mensagens da sala
  fetchMessages(roomId, params = {}) {
    return axios.get(`${this.url}/${roomId}/messages`, { params });
  }

  // Enviar mensagem na sala
  sendMessage(roomId, data) {
    return axios.post(`${this.url}/${roomId}/messages`, {
      chat_room_message: data,
    });
  }

  // Enviar mensagem com anexos (supports multiple files)
  sendMessageWithAttachment(roomId, files, content = '', replyTo = null) {
    const formData = new FormData();
    // Support both single file and array of files
    const fileArray = Array.isArray(files) ? files : [files];
    fileArray.forEach(file => {
      formData.append('chat_room_message[attachments][]', file);
    });
    if (content) formData.append('chat_room_message[content]', content);
    if (replyTo)
      formData.append(
        'chat_room_message[content_attributes][in_reply_to]',
        replyTo
      );
    return axios.post(`${this.url}/${roomId}/messages`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new ChatRoomsAPI();
